import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";


const ProcesoComercialIngenieria = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal">
                <br /> <h1>Procesos y Actividades Ingeniería</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div clasName="Text_Buttons_Radio_buttons">
                <p clasName="ParrafoPrincipal">
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre Del Proceso</th>
                <th>Descripción</th>
                <th>Documentación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <p>
                    <b>06 Entrega de Servicios a Cliente</b>
                  </p>
                </td>
                <td>
                  <p>
                    Cerrar formalmente el proceso 
                    de implementación, capacitación, asegurando la 
                    satisfacción del cliente y su adopción del servicio. 
                    Formalizando la entrega y habilitar el soporte postventa.
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/proceso-comercial-ingenieria/entrega-servicio-cliente"
                  >
                    Procedimiento
                  </Button>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/proceso-comercial-ingenieria/entrega-servicio-cliente-raci"
                  >
                    Matriz RACI
                  </Button>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <p>
                    <b>07 Soporte a Cliente Total </b>
                  </p>
                </td>

                <td>
                  <p>
                    Acompañar al cliente en la correcta adopción y 
                    uso de la solución implementada, asegurando su operación continua 
                    y eficiente, atendiendo las posibles incidencias o fallas que se 
                    presenten durante el tiempo de soporte al cliente.
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/proceso-comercial-ingenieria/soporte-cliente-total"
                  >
                    Procedimiento
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default ProcesoComercialIngenieria;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
